import { render, staticRenderFns } from "./ManuscriptFolderList.vue?vue&type=template&id=fc89dae4&scoped=true"
import script from "./ManuscriptFolderList.vue?vue&type=script&lang=ts"
export * from "./ManuscriptFolderList.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptFolderList.vue?vue&type=style&index=0&id=fc89dae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc89dae4",
  null
  
)

export default component.exports